import { graphql } from "gql";

const DECLINE_CALL_MUTATION = graphql(`
  mutation DeclineCall($id: ID!) {
    declineCall(id: $id) {
      ...Call
    }
  }
`);

export default DECLINE_CALL_MUTATION;
